import React from 'react';

const STATUS_GLYPHS = {
  ready: '✓', short: '⏱', block: '⨯', apcm: '◆',
};
const STATUS_LABELS = {
  ready: 'Met', short: 'Short', block: 'Blocked', apcm: 'APCM',
};

export function StatusPill({ status, sm }) {
  const label = STATUS_LABELS[status] || status;
  const glyph = STATUS_GLYPHS[status] || '';
  return (
    <span className={`status-pill ${status} ${sm ? 'sm' : ''}`}>
      {glyph && <span className="status-glyph" aria-hidden="true">{glyph}</span>}
      {label}
    </span>
  );
}
